import { Card, CardHeader, CardTitle } from '@/components/ui/card'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import type { Invoice } from '@/pages/InvoicesPage.types'

export function InvoiceLineItemsCard({ invoice }: { invoice: Invoice }) {
  const breakdown =
    invoice.breakdown ??
    invoice.tax_rows?.map((row) => ({ label: `${row.name} (${row.percentage}%)`, tax: row.amount }))
  const totalTax = invoice.total_tax ?? invoice.tax

  return (
    <Card className="overflow-hidden">
      <CardHeader className="border-b border-border px-4 py-3">
        <CardTitle className="text-body font-semibold">Line items</CardTitle>
      </CardHeader>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Description</TableHead>
            <TableHead className="text-right">Amount</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {invoice.line_items.map((lineItem) => (
            <TableRow key={lineItem.id}>
              <TableCell>{lineItem.description}</TableCell>
              <TableCell className="text-right tabular-nums">{lineItem.amount}</TableCell>
            </TableRow>
          ))}
          {invoice.discount_row && (
            <TableRow className="border-t border-border">
              <TableCell>Discount Code {invoice.discount_row.label}</TableCell>
              <TableCell className="text-right tabular-nums">
                {invoice.discount_row.reduction}
              </TableCell>
            </TableRow>
          )}
          {(invoice.discount_row || !breakdown?.length) && (
            <TableRow>
              <TableCell className="font-semibold">Total</TableCell>
              <TableCell className="text-right font-semibold tabular-nums">
                {invoice.total}
              </TableCell>
            </TableRow>
          )}
          {breakdown?.length && invoice.subtotal && (
            <>
              <TableRow className="border-t border-border">
                <TableCell className="font-medium">Subtotal</TableCell>
                <TableCell className="text-right tabular-nums">{invoice.subtotal}</TableCell>
              </TableRow>
              {breakdown.map((row) => (
                <TableRow key={row.label}>
                  <TableCell>{row.label}</TableCell>
                  <TableCell className="text-right tabular-nums">{row.tax}</TableCell>
                </TableRow>
              ))}
              <TableRow>
                <TableCell className="font-medium">
                  {invoice.tax_total_label ?? 'Total VAT'}
                </TableCell>
                <TableCell className="text-right tabular-nums">{totalTax}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="font-semibold">Total payable</TableCell>
                <TableCell className="text-right font-semibold tabular-nums">
                  {invoice.total}
                </TableCell>
              </TableRow>
              {invoice.legend && (
                <TableRow>
                  <TableCell colSpan={2} className="text-body-sm text-muted-foreground">
                    {invoice.legend}
                  </TableCell>
                </TableRow>
              )}
            </>
          )}
        </TableBody>
      </Table>
    </Card>
  )
}
